<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      title="抵扣券"
      :visible="dialogVisible"
      width="500px"
      @close="handleClose"
      append-to-body
      center>
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item label="优惠券类型" style="width: 100%;">
          <el-select v-model="form.region" placeholder="请选择活动区域" @change="handleChange">
            <el-option label="小时券" value="shanghai"></el-option>
            <el-option label="代金券" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="抵扣" style="width: 100%;">
          <el-input placeholder="请输入内容" v-model="form.input">
            <template slot="append">{{form.region | title}}</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import showdialog from '@/minxs/showdialog'

export default {

  data() {
    return {
      form: {
        region: 'shanghai',
        input: '',
      },
    };
  },
  mixins:[showdialog],
  filters: {
    title(v){
      // console.log(v)
      return v === 'shanghai' ? '小时' : '元'
    }
  },
  methods: {
    handleChange() {
    },
    handleClick() {
      // console.log(this.form);
    },
  }
};
</script>
